// extracted by mini-css-extract-plugin
module.exports = {"categoryContainer":"category-dropwdown_categoryContainer__EtnoN"};